import * as helpers from '../../core/js/helpers';
import StratisMap from '../../core/components/map/map';
import Dropdown from '../../core/js/components/dropdown';

document.addEventListener('DOMContentLoaded', () => {
    const initMap = () => {
        const mapElement = document.querySelector('[data-map]');

        if (!mapElement || helpers.hasClass(mapElement, '-is-initialized')) {
            return;
        }

        helpers.addClass(mapElement, '-is-initialized');

        const getMapPadding = () => (helpers.getViewport() !== 'smartphone' ? [50, 60, 30, 500] : [50, 30, 30, 50]);

        const isLocaliser = helpers.hasClass(mapElement, 'map-localiser');

        // padding for localiser
        const padding = isLocaliser ? [50, 30, 30, 50] : getMapPadding();

        const maps = new StratisMap('[data-map]', {
            devMode: {
                init: true,
                popupUrl: '/map-popup.html',
            },
            padding, // default value
        });

        if (!isLocaliser) {
            window.addEventListener('resize', () => maps.updateBounds(getMapPadding()));
        }

        const leftPanelDropdown = document.querySelector('.map-template__left-panel');

        const updateActiveResults = (e) => {
            if (!e.params || !e.params.uids) {
                return;
            }
            const uid = Array.isArray(e.params.uids) && e.params.uids.length ? e.params.uids[0] : e.params.uids;

            [...leftPanelDropdown.querySelectorAll('.map-search-results__item')]
                .forEach(result => helpers.removeClass(result, '-is-active'));

            const activeResult = leftPanelDropdown.querySelector(`[data-uid="${uid}"]`);
            if (activeResult) {
                const itemWrap = helpers.findAncestor(activeResult, 'map-search-results__item');
                if (itemWrap) {
                    helpers.addClass(itemWrap, '-is-active');
                }
            }
        };

        if (leftPanelDropdown) {
            const mapLeftPanel = new Dropdown(leftPanelDropdown, {
                wrapperClass: 'map-template__left-panel',
                dropdownClass: 'map-template__left-container',
                closeOnOutsideClick: false,
                outsideToggle: true,
                outsideToggleId: 'map-template__panel-toggle',
                opened: ['desktop', 'tablet'],
                afterOpen: () => {
                    maps.updateBounds([50, 30, 30, 410]);
                },
                afterClose: () => {
                    maps.updateBounds([50, 30, 30, 50]);
                },
            });

            mapLeftPanel.selector.addEventListener('click', (e) => {
                if (helpers.hasClass(e.target, 'filters__show-btn')) {
                    Dropdown.onTogglerClick.apply(mapLeftPanel);
                }
            });

            // CustomEvent
            maps.addListener('popupShow', updateActiveResults);
        }

        const replaceText = (element) => {
            const altText = element.getAttribute('data-alt-text');
            const defaultText = element.innerText;

            if (altText) {
                element.innerText = altText;
                element.setAttribute('data-alt-text', defaultText);
            }
        };

        const changeState = (toggle, event) => {
            const target = document.getElementById(toggle.getAttribute('data-target'));

            if (!target) {
                helpers.addClass(toggle, '-is-hidden');
            }

            const targetState = target.getAttribute('aria-hidden');
            const relatedToggels = [...document.querySelectorAll(`[data-target="${target.id}"]`)];
            const customRelatedTarget = target.getAttribute('data-custom-related');
            const customRelatedObject = {};

            if (!targetState) {
                console.error('Target block should have "aria-hidden" attribute: ', target);
                return false;
            }

            if (customRelatedTarget) {
                customRelatedObject.element = document.getElementById(customRelatedTarget.split(',')[0]);
                customRelatedObject.class = customRelatedTarget.split(',')[1].trim();
            }

            if (target.id === 'map' && targetState === 'true') {
                if (window.innerWidth > 767) {
                    toggle.click();
                }
            }

            if (!event) {
                if (targetState === 'false') {
                    relatedToggels.forEach((relatedToggle) => {
                        helpers.addClass(relatedToggle, '-is-active');
                    });

                    if (customRelatedObject.element) {
                        helpers.addClass(customRelatedObject.element, customRelatedObject.class);
                    }
                } else {
                    relatedToggels.forEach((relatedToggle) => {
                        helpers.removeClass(relatedToggle, '-is-active');
                        replaceText(relatedToggle);
                    });

                    if (customRelatedObject.element) {
                        helpers.removeClass(customRelatedObject.element, customRelatedObject.class);
                    }
                }
            } else if (event && event.type === 'click') {
                if (targetState === 'false') {
                    target.setAttribute('aria-hidden', true);

                    relatedToggels.forEach((relatedToggle) => {
                        helpers.removeClass(relatedToggle, '-is-active');
                        replaceText(relatedToggle);
                    });

                    if (customRelatedObject.element) {
                        helpers.removeClass(customRelatedObject.element, customRelatedObject.class);
                    }
                } else {
                    target.setAttribute('aria-hidden', false);

                    relatedToggels.forEach((relatedToggle) => {
                        helpers.addClass(relatedToggle, '-is-active');
                        replaceText(relatedToggle);
                    });

                    if (customRelatedObject.element) {
                        helpers.addClass(customRelatedObject.element, customRelatedObject.class);
                    }
                }

                maps.updateSize();
            }
        };

        const toggles = [...document.querySelectorAll('.js-map-toggle')];

        if (toggles.length) {
            toggles.forEach((toggle) => {
                changeState(toggle);

                toggle.addEventListener('click', (event) => {
                    changeState(toggle, event);
                });

                window.addEventListener('resize', (event) => {
                    changeState(toggle, event);
                });
            });
        }
    };

    initMap();

    window.addEventListener('initMap', initMap);


    // TEMP FIlter imitation.
    // setTimeout(() => {
    //     fetch(`${window.location.origin}/map-data-test.html`)
    //         .then(response => response.text())
    //         .then((data) => {
    //             const mapHTML = helpers.parseToHtml(data);
    //
    //             const features = StratisMap.HTMLtoFeatures([...mapHTML.querySelectorAll('.js-map-marker')]);
    //             const layers = StratisMap.HTMLtoLayers([...mapHTML.querySelectorAll('[data-layer]')]);
    //
    //             maps.update(features, layers);
    //
    //             // If you want also update DOM you can do this like this: (But you should pass HTML elements not ol objects. Be careful).
    //             // const map = maps.mapContextContainer.querySelector('[data-map]');
    //             // const dataWrapper = map.querySelector('.map__data');
    //             // dataWrapper.innerHML = '';
    //             //
    //             // features.forEach(el => map.appendChild(el));
    //             // layers.forEach(el => map.appendChild(el));
    //         });
    // }, 5000);


    // const randomFeatures = StratisMap.generateRandomFeatures(1000);
    // setTimeout(() => {
    //     maps.updateFeatures(randomFeatures);
    // }, 1000);

    // console.log(maps);
});
